import { ContractDetails, Product, ProductGroep, ZelfRegelenDetails } from '@ap/interface-apix-mijn-overzicht';

export const INSURANCE_ACTIVE = 'show-overview-insurance-accounts';
export const PRODUCT_CATALOG_ENABLED = 'mijn-omgeving.product-catalog';
export const IDEAL_ENABLED = 'allow-ideal-profiles';

export const defaultContractDetails: ContractDetails = { is_zakelijk: false, is_zzp: false, gebruik_rekening_filter: false };

export const defaultAsyncConditions: AsyncConditions = {
    insuranceEnabled: false,
    productCatalogEnabled: false,
    idealEnabled: false
};

export const defaultZelfRegelenDetails: ZelfRegelenDetails = {
    is_meerderjarig: true,
    heeft_betaalpas: false,
    heeft_digipas: false,
    heeft_digicode: false,
    heeft_toegang_tot_kind_rekeningen: false,
    heeft_bizcuit_koppeling: false,
    heeft_afbetaalde_rekening: false,
    productgroepen: [ProductGroep.OVERIG],
    mag_aflossingsvrij_hypotheek_omzetten: false,
    kan_nieuwe_betaalpas_aanvragen: false,
    kan_hypotheek_extra_storten: false
};

export interface ConditionsConfig {
    level: number;
    keyPart: string;
    condition: string;
    businessCondition?: string;
}

export interface AsyncConditions {
    insuranceEnabled: boolean;
    productCatalogEnabled: boolean;
    idealEnabled: boolean;
}

export interface ConditionParameters {
    producten: Product[];
    zelfRegelenDetails: ZelfRegelenDetails;
    contractDetails: ContractDetails;
    asyncConditions: AsyncConditions;
}

export interface RekeningSelectieDTO {
    rekeningen: string[];
}
